import { render, staticRenderFns } from "./WinAMiniGame.vue?vue&type=template&id=1fef1420"
import script from "./WinAMiniGame.vue?vue&type=script&lang=js"
export * from "./WinAMiniGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports